"use strict";

angular.module("vendor")
.controller("SectionCatalogEdit", function(
    $scope, $state, $stateParams, $q, $interval, $location, $timeout, gettextCatalog, FlashBag, Language, Catalog, CatalogEntryService,
    FormError, ModalService, CatalogSharingGroup, Workflow, PatternService, StateExtensionService, CatalogClone, UserService,
    common, CATALOG_HEADER_OFFSET, EMAIL_MAXLENGTH
) {
    var _this = this;
    var defaultSharingType = "region";
    var userPromises = [];

    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    $scope.catalogId = $stateParams.id;
    $scope.isCatalogFetched = false;
    $scope.Catalog = {
        enabled: true
    };
    $scope.vendorDepartments = [];
    $scope.pattern = PatternService;
    $scope.catalogCloneService = CatalogClone;
    $scope.catalogFactory = Catalog;
    $scope.CatalogName = null;
    $scope.allowMarketManagement = null;
    $scope.isArray = angular.isArray;
    $scope.groupPopulation = {
        count: 0,
        total: 0
    };

    /* Next variables are declared inside object to solve the 2 way binding of ui-Tabs directive's copied scope */
    $scope.nestedData = {
        groupMembershipSelected: null,
        productAutoCompleteText: ""
    };

    $scope.catalogEntryService = CatalogEntryService;

    $scope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        _this.updateCatalogStatus();
    });

    $scope.$on("ProductAutoCompleteClear", function(evt) {
        $scope.catalogEntry = {}
    });

    $scope.$watch("activeTab", function() {
        common.scrollToTop();
    });

    var userPromise = UserService.isUserFetched().then(function onSuccess(user) {
        if (user && user.vendor) {
            $scope.isSalesOutsideCommunityAllowed = user.vendor.is_sales_outside_community_allowed;
            $scope.vendorDepartments = user.vendor.departments;
            $scope.allowMarketManagement = user.vendor.allow_market_management;
        }
    });
    userPromises.push(userPromise);

    this.applyGroupSharing = function(form) {
        $scope.isFormGroupSharingSubmitted = true;
        if (form.$valid) {
            CatalogSharingGroup.saveGroupLink($scope.Catalog.id, $scope.nestedData.groupMembershipSelected.id)
            .then(function onSuccess(data) {
                $scope.groupLink = data;
                $scope.Catalog.group_link_id = data.id;
                $scope.nestedData.groupMembershipSelected = $scope.groupLink.membership;
                $scope.$broadcast("fetchGroupLink", $scope.Catalog.group_link_id);

                if ($scope.groupLink.membership.group.community_type == "vendor") {
                    $scope.nestedData.groupSharingTypeSelected = "region";
                    _this.setGroupSharingType();
                }
            }).finally(function() {
                refreshCatalogSharingType("group");
                $scope.isFormGroupSharingSubmitted = false;
                updatePopulationCount(null);
            });
        }
        else {
            FormError.focus(form.$name, CATALOG_HEADER_OFFSET);
        }
    };

    this.removeGroupSharing = function(form) {
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Catalog Confirmation"),
                    context: gettextCatalog.getString("You are about to change the community. You will lose remaining configurations"),
                    message: gettextCatalog.getString("Do you want to continue anyway?")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function onSuccess(result) {
                if (result) {
                    CatalogSharingGroup.removeGroupLink($scope.Catalog.id, $scope.groupLink.id)
                    .$promise.then(function onSuccess(data) {
                        $scope.nestedData.groupMembershipSelected = null;
                        $scope.nestedData.groupSharingTypeSelected = null;
                        $scope.groupSharingType = null;
                        $scope.groupLink = null;
                        $scope.Catalog.group_link_id = null;
                    }).finally(function() {
                        refreshCatalogSharingType("group");
                        updatePopulationCount(null);
                        _this.setGroupImage(null);
                    });
                }
            });
        });
    };

    this.validateAndSave = function(form) {
        $scope.submitCatalog = true;
        var error_count = Object.keys(form.$error).length;
        if (error_count === 0 || (error_count === 1 && form.$error.used)) {
            this.saveCatalog(form);
        }
        else {
            FormError.focus(form.$name, CATALOG_HEADER_OFFSET);
        }
    };

    this.saveCatalog = function(form) {
        var promise = Catalog.save($scope.Catalog);
        promise.then(
            function onSuccess(data) {
                form.code.$setValidity("used", true);
                if (!$scope.catalogId) {
                    Workflow.saveAndContinueAt($scope.Catalog, "catalogEdit", {id: data.id});
                }
                else {
                    $scope.CatalogName = data.name;
                    StateExtensionService.updateUrlParams({"#": "products"});
                    _this.updateCatalogStatus();
                }
            },
            function onError(response) {
                if (response.data["code"]) {
                    form.code.$setValidity("used", false);
                    _.defer(function() {
                        FormError.focus(form.$name, CATALOG_HEADER_OFFSET);
                    });
                }
                else {
                    form.code.$setValidity("used", true);

                    if (response.data["detail"]) {
                        FlashBag.alertWithContainer("danger", "flash-catalog", response.data.detail);
                    }

                    if (response.data["quantity_max_per_order"]) {
                        FlashBag.alertWithContainer("danger", "flash-catalog", response.data.quantity_max_per_order);
                    }

                    if (response.data["quantity_min_per_order"]) {
                        FlashBag.alertWithContainer("danger", "flash-catalog", response.data.quantity_min_per_order);
                    }
                    common.scrollToTop();
                }
            }
        );
    };

    this.updateWizardMenu = function() {
        return checkCatalogStatus().$promise.then(function onSuccess(data) {
            $scope.catalogStatus = data[0];
        });
    };

    this.updateCatalogStatus = function() {
        return _this.updateWizardMenu().then(function onSuccess() {
            var section = updateWorkFlowData();
            if (section) {
                StateExtensionService.updateUrlParams({"#": section});
            }
            activateTab();
        });
    };

    function updateWorkFlowData() {
        var formData = Workflow.getFormData("catalogEdit");

        if (formData && formData.id === $scope.catalogId) {
            $scope.Catalog = formData;
        }

        if (formData && formData["section"]) {
            var section = formData["section"];
            delete formData["section"];
            return section;
        }
    }

    function getSharingTabIndex() {
        if ($scope.catalogStatus.product.status === "disabled") {
            return 0;
        }
        else if ($scope.catalogStatus.sharing.status === "disabled") {
            if ($scope.catalogStatus.details.status === "incomplete") {
                return 0;
            }
            else {
                return 1;
            }
        }
        return 2;
    }

    function updateSharingAnchor() {
        if (isSharingTypeActive("authorized")) {
            StateExtensionService.updateUrlParams({"#": "sharing-customer"});
        }
        else if (isSharingTypeActive("group")) {
            StateExtensionService.updateUrlParams({"#": "sharing-group"});
        }
        else {
            StateExtensionService.updateUrlParams({"#": "sharing-region"});
        }
    }

    function activateTab() {
        var section = $location.hash();

        if (section) {
            var tabsMapping = {
                "header": 0,
                "products": $scope.catalogStatus.product.status === "disabled" ? 0 : 1,
                "sharing": getSharingTabIndex(),
                "sharing-region": getSharingTabIndex(),
                "sharing-customer": getSharingTabIndex(),
                "sharing-group": getSharingTabIndex()
            };
            $scope.activeTab = tabsMapping[section];
            if ($scope.activeTab === 0) {
                StateExtensionService.updateUrlParams({"#": "header"});
            }
            else if ($scope.activeTab === 1) {
                StateExtensionService.updateUrlParams({"#": "products"});
            }
            else if ($scope.activeTab === 2) {
                if (section === "sharing") {
                    updateSharingAnchor();
                }
                else {
                    $timeout(function() {
                        $(".nav-tabs a[href=\"#" + section + "\"]").tab("show");
                    });
                }
            }
        }
        else {
            if ($scope.catalogStatus.details.status === "incomplete") {
                $scope.activeTab = 0;
                StateExtensionService.updateUrlParams({"#": "header"});
            }
            else if ($scope.catalogStatus.product.status === "incomplete") {
                $scope.activeTab = 1;
                StateExtensionService.updateUrlParams({"#": "products"});
            }
            else if ($scope.catalogStatus.sharing.status === "incomplete") {
                $scope.activeTab = 2;
                updateSharingAnchor();
            }
        }

        if (!$scope.activeTab) {
            $scope.activeTab = 0;
            StateExtensionService.updateUrlParams({"#": "header"});
        }
    }

    this.updateAnchor = function(anchor) {
        StateExtensionService.updateUrlParams({"#": anchor});
        if (anchor === "sharing") {
            updateSharingAnchor();
        }
    };

    this.goBack = function() {
        if ($scope.activeTab === 2) {
            $scope.activeTab = 1;
            StateExtensionService.updateUrlParams({"#": "products"});
        }
        else if ($scope.activeTab === 1) {
            $scope.activeTab = 0;
            StateExtensionService.updateUrlParams({"#": "header"});
        }
        _this.updateWizardMenu();
    };

    function checkCatalogStatus() {
        return Catalog.getStatus($scope.catalogId);
    }

    this.finish = function() {
        _this.updateWizardMenu().then(function onSuccess(data) {

            if ($scope.catalogStatus.overall.status != "complete") {
                ModalService.showModal({
                    templateUrl: require("core/confirmation/confirmation.modal.html"),
                    controller: "Confirmation",
                    controllerAs: "ConfirmationCtrl",
                    inputs: {
                        $attrs: {
                            title: gettextCatalog.getString("Catalog Confirmation"),
                            context: gettextCatalog.getString("This catalog is unfinished. It won' be seen by clients"),
                            message: gettextCatalog.getString("Do you want to continue anyway?")
                        }
                    }
                }).then(function onSuccess(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function(e) {
                        modal.element.remove();
                    });
                    modal.close.then(function onSuccess(result) {
                        if (result) {
                            $state.go("catalogsList");
                        }
                    });
                });
            }
            else {
                $state.go("catalogsList");
            }
        });
    };

    this.fetchAll = function() {
        if ($scope.catalogId) {
            Catalog.get($scope.catalogId).$promise.then(
                function onSuccess(data) {
                    $scope.Catalog = data;
                    $scope.CatalogName = data.name;
                    $scope.isCatalogFetched = true;

                    var promises = [];
                    var promise = CatalogSharingGroup.fetchGroupMemberships().then(function onSuccess(response) {
                        $scope.groupMemberships = response.data;
                    });
                    promises.push(promise);

                    if (_this.isShareTypeDisplayAvailable("group")) {
                        if ($scope.Catalog.group_link_id) {
                            promises.push(fetchGroupLink());
                        }

                        $q.all(promises).then(function onSuccess() {
                            _this.setGroupImage();
                        });
                    }

                    _this.updateCatalogStatus().then(function() {
                        $scope.$watch(function() {
                            return $location.hash();
                        }, function(newValue, oldValue) {
                            activateTab();
                        });
                    });
                }
            );
        }
        else {
            this.updateCatalogStatus();
        }
    };

    this.getSharingTypeTabClass = function(sharingType) {
        if (isSharingTypeActive(sharingType))
            return "active";
        else if ($scope.Catalog.sharing_type != null)
            return "disabled";
    };

    this.getSharingTypeTabContentClass = function(sharingType) {
        if (isSharingTypeActive(sharingType))
            return "active";
    };

    this.isShareTypeDisplayAvailable = function(sharingType) {
        return $scope.Catalog.sharing_type == null || $scope.Catalog.sharing_type === sharingType;
    };

    this.refreshCatalogSharingTypeToRegion = function() {
        refreshCatalogSharingType("region");
    };

    this.refreshCatalogSharingTypeToGroup = function(location) {
        refreshCatalogSharingType("group").finally(function() {
            CatalogSharingGroup.refreshGroupSharingType($scope.groupLink.id, $scope.nestedData.groupSharingTypeSelected).finally(function() {
                _this.updateWizardMenu();
                updatePopulationCount(location);
            });
        });
    };

    this.refreshSharingGroupPopulation = function(location) {
        updatePopulationCount(location);
    };

    this.setGroupImage = function() {
        if ($scope.groupMemberships) {
            $scope.groupImage = ($scope.nestedData.groupMembershipSelected) ? $scope.nestedData.groupMembershipSelected.group.image_path.thumbnail : null;
        }
    };

    this.refreshGroupSharingType = function(previousChoice) {
        if ($scope.groupSharingType) {
            ModalService.showModal({
                templateUrl: require("core/confirmation/confirmation.modal.html"),
                controller: "Confirmation",
                inputs: {
                    $attrs: {
                        title: gettextCatalog.getString("Catalog Confirmation"),
                        context: gettextCatalog.getString("You are about to change the sharing. Customer selected won't be able to see this catalog anymore."),
                        message: gettextCatalog.getString("Do you want to continue anyway?")
                    }
                }
            }).then(function onSuccess(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function onSuccess(result) {
                    if (result) {
                        updateGroupSharing();
                    }
                    else {
                        $scope.nestedData.groupSharingTypeSelected = previousChoice;
                    }
                });
            });
        }
        else {
            updateGroupSharing();
        }

    };

    function updateGroupSharing() {
        CatalogSharingGroup.refreshGroupSharingType($scope.groupLink.id, $scope.nestedData.groupSharingTypeSelected)
        .finally(function() {
            $scope.groupSharingType = $scope.nestedData.groupSharingTypeSelected;
            _this.updateWizardMenu();
            updatePopulationCount(null);
        });
    }

    function fetchGroupLink() {
        if ($scope.Catalog.group_link_id) {
            return CatalogSharingGroup.getGroupLink($scope.Catalog.group_link_id)
            .$promise.then(function onSuccess(data) {
                $scope.groupLink = data;
                $scope.nestedData.groupMembershipSelected = $scope.groupLink.membership;
                $scope.nestedData.groupSharingTypeSelected = $scope.groupLink.sharing_type;
                $scope.groupSharingType = $scope.nestedData.groupSharingTypeSelected;
                $scope.Catalog.group_link_id = data.id;
            });
        }
        else {
            var deferred = $q.defer();
            deferred.resolve(true);
            return deferred.promise;
        }
    }

    function updatePopulationCount(location) {
        var promises = [];

        if (!$scope.groupLink) {
            promises.push(fetchGroupLink());
        }

        $q.all(promises).then(function onSuccess() {
            if ($scope.groupLink) {
                if (location !== null)
                    location = encodeURIComponent(location);

                CatalogSharingGroup.calculatePopulation($scope.Catalog.id, $scope.groupLink.membership.group.id, location)
                .then(function onSuccess(response) {
                    var data = response.data;
                    $scope.groupPopulation.count = data.count;
                    $scope.groupPopulation.total = data.total;
                });
            }
            else {
                $scope.groupPopulation.count = $scope.groupPopulation.total = 0;
            }
        });
    }

    function isSharingTypeActive(sharingType) {
        return ($scope.Catalog.sharing_type == null && sharingType === defaultSharingType)
            || ($scope.Catalog.sharing_type === sharingType);
    }

    function refreshCatalogSharingType(sharingType) {
        var deferred = $q.defer();
        CatalogSharingGroup.refreshSharingType($scope.Catalog.id, sharingType)
        .then(function onSuccess(response) {
            $scope.Catalog.sharing_type = response.data.sharing_type;
            defaultSharingType = sharingType;
            _this.updateWizardMenu();
            deferred.resolve(true);
        }, function() {
            deferred.reject(true);
        });
        return deferred.promise;
    }

    this.refreshCatalogGroupRegionHasTargetedZones = function() {
        CatalogSharingGroup.refreshGroupRegionHasTargetedZones($scope.groupLink.id)
        .then(function onSuccess(response) {
            _this.updateWizardMenu();
        });
    };

    $q.all(userPromises).then(function onSuccess() {
        _this.fetchAll();
    });

    $scope.$on("updateWizardMenu", function() {
        _this.updateWizardMenu();
    });

    $scope.$on("updateCatalogStatus", function() {
        _this.updateCatalogStatus();
    });

    $scope.$on("goBack", function() {
        _this.goBack();
    });

    $scope.$on("refreshCatalogSharingType", function($event, sharingType) {
        refreshCatalogSharingType(sharingType);
    });

    $scope.$on("market.directive.refreshFunction", function($event, referenceType, zones) {
        if (referenceType === "catalog_group_link")
            _this.refreshCatalogSharingTypeToGroup(zones);
    });

    $scope.$on("updatePopulationCount", function() {
        updatePopulationCount(null);
    });
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-edit.controller.js
// module id = 980
// module chunks = 0